import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ViewRoutingModule } from './view-routing.module';
import { ViewComponent } from './pages/view/view.component';
import { SharedModule } from '../shared/shared.module';
import { PanelComponent } from './components/panel/panel.component';
import { MaterialModule } from '../material.module';
import { ViewChaptersDrawerComponent } from './components/view-chapters-drawer/view-chapters-drawer.component';
import { ViewChaptersListComponent } from './components/view-chapters-list/view-chapters-list.component';
import { ViewState } from './state/view.state';
import { NgxsModule } from '@ngxs/store';
import { EngineModule } from '../engine/engine.module';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ViewChaptersListItemComponent } from './components/view-chapters-list/view-chapters-list-item/view-chapters-list-item.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      ViewState
    ]),
    CommonModule,
    MaterialModule,
    ViewRoutingModule,
    SharedModule,
    EngineModule,
    BookmarksModule,
    FontAwesomeModule,
    ReactiveFormsModule
  ],
  declarations: [
    ViewComponent,
    PanelComponent,
    ViewChaptersDrawerComponent,
    ViewChaptersListComponent,
    ViewChaptersListItemComponent
  ]
  
})
export class ViewModule { }
